import customer from '../../../../assets/img/ic_customer.png';
import program from '../../../../assets/img/ic_programs.png';
import doctors from '../../../../assets/img/ic_doctors.png'
import users from '../../../../assets/img/ic_total_app_users.png'
import signup from '../../../../assets/img/ic_new_signups.png'

const data = {
  Data: [
    {
      heading: "Overview",
      client: "32",
      clientSubtitle: "Clients",
      programs: "80",
      programsSubtitle: "Programs",
      doctor: "127",
      doctorSubtitle: "Doctors",
      "image1": customer,
      "image2": program,
      "image3": doctors,

      totalAppUsersHeading: "App Users",
      totalAppUsers: "8,458",
      totalAppUsersSubtitle: "Total App Users",
      totalSignupUsers: "1,002",
      totalSignupSubtitle: "New Signups",

      "image4": users,
      "image5": signup,
    },
  ],
};

export default data;
